import { Box, Stack, Typography } from '@mui/material';
import { VacancyFunnel, VacancyInvitations } from 'types/vacancyStats';
import { formatAcceptHours, formatCount, formatPercent } from 'utils/vacancyStatsFormat';
import { FUNNEL_COLORS, StatPill, WidgetCard } from './shared';

interface Props {
  funnel: VacancyFunnel;
  invitations: VacancyInvitations;
}

const FunnelWidget = ({ funnel, invitations }: Props) => {
  // Воронка считается по ВСЕМ кандидатам (знаменатель — total), не по «оценённым».
  const stages = [
    // { label: 'Приглашён', value: funnel.invited },
    { label: 'Определение навыков', value: funnel.inProgressExtract },
    { label: 'Интервью', value: funnel.inProgressInterview },
    { label: 'Завершил', value: funnel.completed },
    { label: 'Не принято', value: funnel.cancelled }
  ];

  const { accepted, pending, expired, avgAcceptHours } = invitations;
  const issued = accepted + pending + expired;
  const acceptHoursLabel = formatAcceptHours(avgAcceptHours);

  // Ширина бара относительно максимума среди этапов (визуальное «сужение» воронки).
  const maxValue = Math.max(funnel.total, ...stages.map((s) => s.value), 1);

  return (
    <WidgetCard overline="Статусы" title="" sx={{ marginLeft: '0 !important' }}>
      <Stack spacing={1.5}>
        {stages.map((stage, index) => {
          const widthPct = Math.max((stage.value / maxValue) * 100, stage.value > 0 ? 4 : 0);
          const color = FUNNEL_COLORS[index];
          return (
            <Box key={stage.label}>
              <Stack
                direction="row"
                alignItems="baseline"
                justifyContent="space-between"
                sx={{ mb: 0.5 }}
              >
                <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                  {stage.label}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 700, color: 'grey.900' }}>
                  {formatCount(stage.value)}
                </Typography>
              </Stack>
              <Box sx={{ height: 12, borderRadius: 999, bgcolor: 'grey.200', overflow: 'hidden' }}>
                <Box
                  sx={{
                    height: '100%',
                    width: `${widthPct}%`,
                    borderRadius: 999,
                    bgcolor: color,
                    transition: 'width 400ms ease'
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>

      <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ mt: 3 }}>
        <StatPill label="Всего" value={formatCount(funnel.total)} />
        <StatPill
          label="Не приняли"
          value={formatCount(funnel.cancelled)}
          color={funnel.cancelled > 0 ? 'error.dark' : 'text.primary'}
        />
        <StatPill label="Приняли" value={formatPercent(funnel.acceptRate)} color="primary.dark" />
        <StatPill
          label="Прошли"
          value={formatPercent(funnel.completionRate)}
          color="success.dark"
        />
      </Stack>
      {acceptHoursLabel && (
        <Typography
          variant="caption"
          sx={{ display: 'block', color: 'text.secondary', mt: 4 }}
        >
          Среднее время отклика «приглашён → принял»
        </Typography>
      )}
      <Stack sx={{ mt: 2 }} justifyContent="center" alignItems="flex-start">
        {acceptHoursLabel && (
          <StatPill label="Ср. отклик" value={acceptHoursLabel} color="primary.dark" />
        )}
      </Stack>
    </WidgetCard>
  );
};

export default FunnelWidget;
